// import React, { useState, useEffect, useRef } from 'react';
// import { 
//   ArrowLeft, 
//   Lock, 
//   Eye, 
//   EyeOff, 
//   CheckCircle2, 
//   Globe,
//   Mail,
//   Smartphone,
//   LockKeyhole,
//   ShieldCheck
// } from 'lucide-react';
// import styles from './Login2.module.css';
// import Logo from '../../Assets/coop-logo.svg'
// import SecureLogo from '../../Assets/secure.png'
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { BASE_URL } from '../../Components/Api/Api';
// import Swal from 'sweetalert2';
// import { BRANDING } from '../../Components/Branding/Branding'

// export default function Login2() {
//   const [step, setStep] = useState(1); // 1 = Email, 2 = OTP, 3 = Password
 
//   // Form States
//   const [email, setEmail] = useState('');
//   const [otp, setOtp] = useState(['', '', '', '', '', '']);
//   const [password, setPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [errorMessage, setErrorMessage] = useState("");
//   const [showErrorMessage, setShowErrorMessage] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const navigate = useNavigate();
//   // UI States
//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [timer, setTimer] = useState(165); 
//   const [language, setLanguage] = useState('English');
  
//   const otpRefs = useRef([]);
// const currentYear = new Date().getFullYear();
//   // Live validation checks
//   const validationRules = {
//     length: password.length >= 8,
//     uppercase: /[A-Z]/.test(password),
//     lowercase: /[a-z]/.test(password),
//     number: /[0-9]/.test(password),
//     specialChar: /[@$!%*?&]/.test(password),
//   };

//   const getPasswordStrength = () => {
//     const passedCount = Object.values(validationRules).filter(Boolean).length;
//     if (!password) return { text: 'None', blocks: 0, color: '' };
//     if (passedCount <= 2) return { text: 'Weak', blocks: 1, color: styles.strengthWeak };
//     if (passedCount <= 4) return { text: 'Medium', blocks: 3, color: styles.strengthMedium };
//     return { text: 'Strong', blocks: 4, color: styles.strengthStrong };
//   };

//   const strength = getPasswordStrength();

//   useEffect(() => {
//     if (step !== 2) return;
//     const interval = setInterval(() => {
//       setTimer((prev) => (prev > 0 ? prev - 1 : 0));
//     }, 1000);
//     return () => clearInterval(interval);
//   }, [step]);

//   const handleOtpChange = (value, index) => {
//     if (isNaN(value)) return;
//     const newOtp = [...otp];
//     newOtp[index] = value.substring(value.length - 1);
//     setOtp(newOtp);
//     if (value && index < 5) otpRefs.current[index + 1].focus();
//   };

//   const handleKeyDown = (e, index) => {
//     if (e.key === 'Backspace' && !otp[index] && index > 0) {
//       otpRefs.current[index - 1].focus();
//     }
//   };

//   const handle1stStep = async () => {
//   setLoading(true);
//   try {
//       const response = await axios.post(`${BASE_URL}/member-auth/login`,
//            {
//               email: email,
//               password: password,
//           }
//       );
//       console.log(response.data)
//       const apiData = response.data?.data || {};
//       const token = apiData?.token;
//       const memberNumber = apiData?.member?.member_number;
//       const memberName = apiData?.member?.name;
//       const memberPhoto = apiData?.member?.passport_photograph;
//       const companyId = apiData?.member?.company_id;
//       const walletBalance = apiData?.member?.wallet_balance;
//       localStorage.setItem('token', token);
//       localStorage.setItem('memberNumber', memberNumber);
//       localStorage.setItem('memberName', memberName);
//       localStorage.setItem('memberPhoto', memberPhoto);
//       localStorage.setItem('companyId', companyId);
//       localStorage.setItem('walletBalance', walletBalance);
//       navigate('/dashboard');

    

   
  
//     } catch (error) {
//       let errorMessage = 'An error occurred. Please try again.';
      
//       if (error.response && error.response.data && error.response.data.message) {
//         const { message } = error.response.data;
    
//         if (typeof message === 'string') {
//           errorMessage = message;
//         } else if (Array.isArray(message)) {
//           errorMessage = message.join('; ');
//         } else if (typeof message === 'object') {
//           // Extract the first key and its message(s)
//           const firstKey = Object.keys(message)[0];
//           const messages = message[firstKey];
//           if (Array.isArray(messages)) {
//             errorMessage = messages.join('; ');
//           } else {
//             errorMessage = messages;
//           }
//         }
//         Swal.fire({
//           icon: 'error',
//           title: 'Oops...',
//           text: errorMessage,
//         });
    
//         // setErrorMessage(errorMessage);
//         // setShowErrorMessage(true);
//       }
//   } finally {
//       setLoading(false);
//   }
// }

//   return (
//     <div className={styles.screenWrapper}>
      
//       {/* LEFT COLUMN: STATIC BRAND SIDEBAR (NO SCROLL) */}
//       <div className={styles.leftSidebar}>
//         <div className={styles.brandTopArea}>
//           {/* <div className={styles.logoImageFallback}> */}
//             {/* <div className={styles.leafIcon}> */}
//              <img
//   src={BRANDING?.coopPrimary?.logo}
//   alt="logo"
//   style={{
//     marginRight: 10,
//     width: 200,
//     height:
//       BRANDING?.coopPrimary?.logo === BRANDING?.coopPrimary?.logo
//         ? 50
//         : 100,
//     objectFit: "contain",
//   }}
// />
//             {/* </div> */}
//           {/* </div> */}
//           {/* <div className={styles.sidebarLogoText}>
//             <h2 style={{textTransform: 'uppercase'}}>{BRANDING?.coopPrimary?.mainName}</h2>
//             <p style={{textTransform: 'uppercase'}}>{BRANDING?.coopPrimary?.secondName} <br/>{BRANDING?.coopPrimary?.thirdName}</p>
//           </div> */}
//         </div>
        
//         <div className={styles.sidebarContent}>
//           <h1>Stronger Together,<br /><span className={styles.greenText}>Better Together.</span></h1>
//           {/* <h1><br /><span className={styles.greenText}>invest and grow financially.</span></h1> */}
//           <div className={styles.shortDivider}></div>
//           <p>Empowering members to save, borrow, invest and grow financially.</p>
//         </div>

//         {/* Floating Illustrative Badges */}
//         <div className={styles.illustrationCenter}>
//           <img src={SecureLogo} alt="Secure Illustration" style={{objectFit: 'contain', height: 200, width: 200}} />
//         </div>

//         <p className={styles.copyrightText}>© {currentYear} RCCG Workers Fund Cooperative. All rights reserved.</p>
//       </div>

//       {/* RIGHT COLUMN: INTERACTIVE VIEW PORTAL (SCROLL ALLOWED IF WINDOW COMPACTS) */}
//       <div className={styles.rightContentArea}>
        
//         <div className={styles.topUtilityRow}>
//           <button 
//             // onClick={() => step > 1 && setStep(step - 1)}
//             // disabled={step === 1}
//             className={`${styles.navBackBtn} ${step === 1 ? styles.invisible : ''}`}
//           >
//             {/* <ArrowLeft size={16} /> */}
//              {/* Back */}
//           </button>
          
//           <div className={styles.langSelector}>
//             <Globe size={14} />
//             <select value={language} onChange={(e) => setLanguage(e.target.value)}>
//               <option value="English">English</option>
//               {/* <option value="French">French</option> */}
//             </select>
//           </div>
//         </div>

//         <div className={styles.portalActionCard}>
          
//           {/* STEP 1: EMAIL REQUEST */}
         
//             <form onSubmit={(e) => {
//     e.preventDefault();
//     handle1stStep();
//   }} className={styles.formSpace}>
//               <div className={styles.cardHeaderArea}>
//                 <div className={styles.lockIconCircle}><Mail size={24} /></div>
//                 <h3>Welcome Back!</h3>
//                 <p>Sign in to your Cooperative Member Portal</p>
//               </div>

//               <div className={styles.cleanInputGroup}>
//                 <label>Email Address</label>
//                 <div className={styles.fieldInteractiveWrapper}>
//                   <Mail className={styles.startFieldIcon} size={18} />
//                   <input 
//                     type="email" 
//                     required 
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     placeholder="name@example.com" 
//                     className={styles.cleanInput} 
//                   />
//                 </div>
//               </div>

//                 <div className={styles.cleanInputGroup}>
//                 <label>Password</label>
//                 <div className={styles.fieldInteractiveWrapper}>
//                   <Lock className={styles.startFieldIcon} size={18} />
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     required
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     className={styles.cleanInput}
//                   />


//                   <button type="button" onClick={() => setShowPassword(!showPassword)} className={styles.endFieldIcon}>
//                     {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
//                   </button>
//                 </div>
//               </div>
// <div style={{display: 'flex', justifyContent: 'flex-end'}}>
// <p style={{cursor: 'pointer', marginTop: 0, marginBottom: 0, fontSize: 14, color: '#16A34A'}}>Forgot Password?</p>
// </div>
//              <button
//   type="submit"
//   className={styles.submitActionBtn}
//   disabled={loading}
// >
//   <LockKeyhole color="white" />
//   {loading ? "Processing your request..." : "Login"}
// </button>
//             </form>
        

        

          
         

          

//           <div className={styles.supportCenterFooter}>
//             Already a registered member but don't have portal access? <span style={{color: '#16A34A', cursor: 'pointer'}} onClick={() => navigate ('/member-registration')}>Click here!</span>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState } from 'react';
import { 
  Globe,
  Eye, 
  EyeOff,
  ArrowRight,
  Building2
} from 'lucide-react';
import styles from './Login2.module.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../Components/Api/Api';
import Swal from 'sweetalert2';
import { BRANDING } from '../../Components/Branding/Branding';
import { GoShieldCheck } from 'react-icons/go';
import { RiPieChart2Fill } from 'react-icons/ri';
import { HiMiniUsers } from 'react-icons/hi2';
import { FaRegUser } from 'react-icons/fa';
import { LuLockKeyhole } from 'react-icons/lu';


export default function Login2() {
  // Form States
  const [identifier, setIdentifier] = useState(''); // Handles Membership Number or Email
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showCompanySelection, setShowCompanySelection] = useState(false);
  const [loginData, setLoginData] = useState(null);
  const [selectedCompanyId, setSelectedCompanyId] = useState('');
  const [emailError, setEmailError] = useState(''); // Direct red error text under input
  const [companies, setCompanies] = useState([]); // Stores fetched companies with { company, member }
  const [companiesLoading, setCompaniesLoading] = useState(false); // Mid-screen loader trigger
  
  // UI States
  const [showPassword, setShowPassword] = useState(false);
  const [language, setLanguage] = useState('English');
  
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

     const handleForgot = () => {
      navigate("/forgot_password");
  };

  // Helper to fetch companies only after a successful login trigger
  const fetchCompanies = async (emailToFetch) => {
    setCompaniesLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/my-active-coop?email=${emailToFetch}`);
      const companyList = response.data?.companies || response.data?.data || [];
      
      setCompanies(companyList);

      if (companyList.length > 0) {
        setEmailError('');
        // Focus on the nested company ID
        setSelectedCompanyId(companyList[0]?.company?.id || '');
        return true; 
      } else {
        setSelectedCompanyId('');
        setEmailError(response.data?.message || 'No company found.');
        return false;
      }
    } catch (error) {
      let errorMessage = 'An error occurred fetching companies. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        const { message } = error.response.data;
        if (typeof message === 'string') errorMessage = message;
        else if (Array.isArray(message)) errorMessage = message.join('; ');
        else if (typeof message === 'object') {
          const firstKey = Object.keys(message)[0];
          const messages = message[firstKey];
          errorMessage = Array.isArray(messages) ? messages.join('; ') : messages;
        }
      }
      setEmailError(errorMessage);
      setCompanies([]);
      setSelectedCompanyId('');
      return false;
    } finally {
      setCompaniesLoading(false);
    }
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/member-auth/login`, {
        email: identifier, 
        password: password,
      });
      
      const apiData = response.data?.data || {};
      setLoginData(apiData);
      
      // Keep ONLY the authentication token saved here
      localStorage.setItem('token', apiData?.token);
      
      // Fetch active cooperatives on successful login verification
      const companiesFetched = await fetchCompanies(identifier);

      if (companiesFetched) {
        setShowCompanySelection(true);
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Account Restricted',
          text: 'Login successful, but we could not find any active companies registered to this account.',
        });
      }
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        const { message } = error.response.data;
        if (typeof message === 'string') errorMessage = message;
        else if (Array.isArray(message)) errorMessage = message.join('; ');
        else if (typeof message === 'object') {
          const firstKey = Object.keys(message)[0];
          const messages = message[firstKey];
          errorMessage = Array.isArray(messages) ? messages.join('; ') : messages;
        }
      }
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCompanySubmit = (e) => {
    e.preventDefault();
    if (!selectedCompanyId) {
      Swal.fire({
        icon: 'warning',
        title: 'Selection Required',
        text: 'Please select a company to proceed.',
      });
      return;
    }

    // Find workspace object matching selected nested company.id
    const selectedWorkspace = companies.find(
      (item) => String(item?.company?.id) === String(selectedCompanyId)
    );

    if (selectedWorkspace) {
      const selectedCompany = selectedWorkspace.company || {};
      const selectedMember = selectedWorkspace.member || {};

      // 1. Save specific company details
      localStorage.setItem('companyId', selectedCompany.id || '');
      localStorage.setItem('companyName', selectedCompany.name || '');

      // 2. Stamp exact member details relative to selected company
      localStorage.setItem('memberNumber', selectedMember.member_number || '');
      localStorage.setItem("memberId", selectedMember.id || "");
      localStorage.setItem('memberPhoneNumber', selectedMember.phone_number || '');
      localStorage.setItem('department', selectedMember.department || '');
      localStorage.setItem('employerName', selectedMember.employer_name || '');
      localStorage.setItem('saveType', selectedMember.savings_type || '');
      localStorage.setItem('memberName', selectedMember.name || '');
      localStorage.setItem('memberAddress', selectedMember.address || '');
      localStorage.setItem('memberPhoto', selectedMember.passport_photograph || '');
      localStorage.setItem('walletBalance', selectedMember.wallet_balance || '');
      localStorage.setItem('memberEmail', selectedMember.email || '');

      navigate('/dashboard'); 
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Invalid company selection.',
      });
    }
  };

  return (
    <div className={styles.screenWrapper}>
      {companiesLoading && (
        <div className={styles.globalLoaderOverlay}>
          <div className={styles.spinnerContainer}>
            <div className={styles.spinner}></div>
            <p className={styles.loadingText}>Fetching registered companies...</p>
          </div>
        </div>
      )}
      
      {/* LEFT COLUMN: BRAND SIDEBAR */}
      <div className={styles.leftSidebar}>
        <div className={styles.sidebarOverlay}></div>
        <div className={styles.sidebarContentWrapper}>
          <div className={styles.brandTopArea}>
            <div className={styles.logoContainer}>
              <img src={BRANDING?.coopPrimary?.logo} alt="RCCG Logo" className={styles.logoImg} />
            </div>
          </div>
          
          <div className={styles.sidebarMidContent}>
            <h1>Stronger Together,<br />Better Together</h1>
            <p>Empowering members to save, borrow, <br /> invest and grow financially.</p>
            <div className={styles.sideBarBottom} />
            <ul className={styles.featuresList}>
              <li>
                <span className={styles.featureIcon}><GoShieldCheck size={25} /></span>
                <div>
                  <strong>Secure & Trusted</strong>
                  <p>Your data is protected with enterprise-grade security</p>
                </div>
              </li>
              <li>
                <span className={styles.featureIcon}><RiPieChart2Fill size={25}/></span>
                <div>
                  <strong>Smart & Transparent</strong>
                  <p>Track your savings, loans and investments in real time</p>
                </div>
              </li>
              <li>
                <span className={styles.featureIcon}><HiMiniUsers size={25}/></span>
                <div>
                  <strong>Member Focused</strong>
                  <p>Built to support your financial wellbeing and future</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* RIGHT COLUMN: INTERACTIVE PORTAL */}
      <div className={styles.rightContentArea}>
        <div className={styles.portalActionCard}>
          
          {!showCompanySelection ? (
            /* --- STEP 1: LOGIN FORM --- */
            <>
              <div className={styles.cardHeaderArea}>
                <h3>Welcome Back!</h3>
                <p>Sign in to your Cooperative Member Portal</p>
              </div>

              <form onSubmit={handleLoginSubmit} className={styles.formSpace}>
                {/* Field 1: Email */}
                <div className={styles.cleanInputGroup}>
                  <label>Email Address</label>
                  <div className={styles.fieldInteractiveWrapper}>
                    <span className={styles.inputPrefixIcon}><FaRegUser size={18} color='#000'/></span>
                    <input 
                      type="text" 
                      required 
                      value={identifier}
                      onChange={(e) => setIdentifier(e.target.value)}
                      placeholder="Enter your email address" 
                      className={styles.cleanInput} 
                    />
                  </div>
                  {emailError && <span className={styles.errorText} style={{ color: 'red', fontSize: '12px' }}>{emailError}</span>}
                </div>

                {/* Field 2: Password */}
                <div className={styles.cleanInputGroup}>
                  <label>Password</label>
                  <div className={styles.fieldInteractiveWrapper}>
                    <span className={styles.inputPrefixIcon}><LuLockKeyhole size={18} color='#000'/></span>
                    <input 
                      type={showPassword ? "text" : "password"}
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter your password"
                      className={styles.cleanInput}
                    />
                    <button type="button" onClick={() => setShowPassword(!showPassword)} className={styles.endFieldIcon}>
                      {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                  </div>
                </div>

                {/* Remember Me & Forgot Password */}
                <div className={styles.formOptionsRow}>
                  {/* <label className={styles.rememberMeLabel}>
                    <input 
                      type="checkbox" 
                      checked={rememberMe} 
                      onChange={(e) => setRememberMe(e.target.checked)} 
                    />
                    <span>Remember me</span>
                  </label> */}
                  <span onClick={handleForgot} 
                  className={styles.forgotPasswordLink}
                  >
                  Forgot Password?
                  </span>
                </div>

                {/* Sign In Button */}
                <button type="submit" className={styles.submitActionBtn} disabled={loading}>
                  <span>{loading ? "Processing..." : "Sign In"}</span>
                  {!loading && <ArrowRight size={18} />}
                </button>
              </form>

              <div className={styles.supportCenterFooter}>
                Don't have portal access? <span style={{color: '#16A34A', cursor: 'pointer'}} onClick={() => navigate('/member-registration')}>Click here!</span>
              </div>
            </>
          ) : (
            /* --- STEP 2: COMPANY SELECTION FORM --- */
            <>
              <div className={styles.cardHeaderArea}>
                <h3>Select Company</h3>
                <p>Choose the company you wish to access today</p>
              </div>

              <form onSubmit={handleCompanySubmit} className={styles.formSpace}>
                <div className={styles.cleanInputGroup}>
                  <label>Associated Company</label>
                  <div className={styles.fieldInteractiveWrapper}>
                    <span className={styles.inputPrefixIcon}><Building2 size={18} color='#000' /></span>
                    <select
                      required
                      value={selectedCompanyId}
                      onChange={(e) => setSelectedCompanyId(e.target.value)}
                      className={styles.cleanInput}
                      style={{ appearance: 'auto', paddingLeft: '40px' }}
                    >
                      <option value="" disabled>-- Select your company --</option>
                      {companies.map((workspace, index) => {
                        const compId = workspace?.company?.id;
                        const compName = workspace?.company?.name || "Unknown Company";
                        return (
                          <option key={compId || index} value={compId}>
                            {compName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                {/* Continue Button */}
                <button type="submit" className={styles.submitActionBtn}>
                  <span>Continue to Dashboard</span>
                  <ArrowRight size={18} />
                </button>

                {/* Go Back to Login Option */}
                <div className={styles.supportCenterFooter}>
                  Want to log in with a different account?{' '}
                  <span 
                    style={{color: '#16A34A', cursor: 'pointer', fontWeight: '500'}} 
                    onClick={() => {
                      setShowCompanySelection(false);
                      setLoginData(null);
                    }}
                  >
                    Go Back
                  </span>
                </div>
              </form>
            </>
          )}

        </div>
      </div>

    </div>
  );
}